import React from 'react';

const ReadyForExtractionIcon: React.FC = () => (
	<svg width='286' height='286' viewBox='0 0 286 286' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<mask id='mask0_3703_23963' maskUnits='userSpaceOnUse' x='123' y='121' width='42' height='42'>
			<rect x='123' y='121' width='42' height='42' fill='#D9D9D9' />
		</mask>
		<g mask='url(#mask0_3703_23963)'>
			<path
				d='M133.5 159.5C132.537 159.5 131.714 159.157 131.028 158.472C130.343 157.786 130 156.963 130 156V128C130 127.037 130.343 126.214 131.028 125.528C131.714 124.843 132.537 124.5 133.5 124.5H147.5L158 135V156C158 156.963 157.657 157.786 156.972 158.472C156.286 159.157 155.462 159.5 154.5 159.5H133.5Z'
				fill='#F2F2F2'
			/>
			<rect x='137' y='142' width='10' height='2' rx='1' fill='#434343' />
			<rect x='137' y='146' width='14' height='2' rx='1' fill='#434343' />
			<rect x='137' y='150' width='14' height='2' rx='1' fill='#434343' />
			<path d='M146 133V124.5H147.5L158 135V137H150C147.791 137 146 135.209 146 133Z' fill='#E1E1E1' />
		</g>
		<circle cx='143' cy='143' r='38.5' stroke='#F0F0F0' />
		<circle opacity='0.8' cx='143' cy='143' r='64.5' stroke='#F0F0F0' />
		<circle opacity='0.7' cx='143' cy='143' r='90.5' stroke='#F0F0F0' />
		<circle opacity='0.5' cx='143' cy='143' r='115.5' stroke='#F0F0F0' />
		<circle opacity='0.3' cx='143' cy='143' r='142.5' stroke='#F0F0F0' />
		<g opacity='0.9'>
			<rect x='70' y='153' width='28' height='28' rx='6' fill='#F2F2F2' />
			<mask id='mask1_3703_23963' maskUnits='userSpaceOnUse' x='76' y='159' width='16' height='16'>
				<rect x='76' y='159' width='16' height='16' fill='#D9D9D9' />
			</mask>
			<g mask='url(#mask1_3703_23963)'>
				<path
					d='M78.6668 172.333C78.3002 172.333 77.9863 172.203 77.7252 171.942C77.4641 171.681 77.3335 171.367 77.3335 171V163C77.3335 162.633 77.4641 162.319 77.7252 162.058C77.9863 161.797 78.3002 161.667 78.6668 161.667H82.6668L84.0002 163H89.3335C89.7002 163 90.0141 163.131 90.2752 163.392C90.5363 163.653 90.6668 163.967 90.6668 164.333V171C90.6668 171.367 90.5363 171.681 90.2752 171.942C90.0141 172.203 89.7002 172.333 89.3335 172.333H78.6668ZM78.6668 171H89.3335V164.333H83.4502L82.1168 163H78.6668V171Z'
					fill='#434343'
				/>
			</g>
		</g>
		<g opacity='0.9'>
			<rect x='184' y='100' width='28' height='28' rx='6' fill='#F2F2F2' />
			<mask id='mask2_3703_23963' maskUnits='userSpaceOnUse' x='190' y='106' width='16' height='16'>
				<rect x='190' y='106' width='16' height='16' fill='#D9D9D9' />
			</mask>
			<g mask='url(#mask2_3703_23963)'>
				<path
					d='M193.333 120C192.967 120 192.653 119.869 192.392 119.608C192.131 119.347 192 119.033 192 118.667V109.333C192 108.967 192.131 108.653 192.392 108.392C192.653 108.131 192.967 108 193.333 108H202.667C203.033 108 203.347 108.131 203.608 108.392C203.869 108.653 204 108.967 204 109.333V118.667C204 119.033 203.869 119.347 203.608 119.608C203.347 119.869 203.033 120 202.667 120H193.333ZM193.333 118.667H202.667V109.333H193.333V118.667ZM194 117.333H202L199.5 114L197.5 116.667L196 114.667L194 117.333Z'
					fill='#434343'
				/>
			</g>
		</g>
		<g opacity='0.6'>
			<rect x='246' y='109' width='20' height='20' rx='2' fill='#F2F2F2' />
			<mask id='mask3_3703_23963' maskUnits='userSpaceOnUse' x='250' y='113' width='12' height='12'>
				<rect x='250' y='113' width='12' height='12' fill='#D9D9D9' />
			</mask>
			<g mask='url(#mask3_3703_23963)'>
				<path
					d='M251.5 118.5V114.5H255.5V118.5H251.5ZM251.5 123.5V119.5H255.5V123.5H251.5ZM256.5 118.5V114.5H260.5V118.5H256.5ZM256.5 123.5V119.5H260.5V123.5H256.5ZM252.5 117.5H254.5V115.5H252.5V117.5ZM257.5 117.5H259.5V115.5H257.5V117.5ZM257.5 122.5H259.5V120.5H257.5V122.5ZM252.5 122.5H254.5V120.5H252.5V122.5Z'
					fill='#1C1B1F'
				/>
			</g>
		</g>
		<g opacity='0.6'>
			<rect x='242' y='173' width='20' height='20' rx='2' fill='#F2F2F2' />
			<mask id='mask4_3703_23963' maskUnits='userSpaceOnUse' x='246' y='177' width='12' height='12'>
				<rect x='246' y='177' width='12' height='12' fill='#D9D9D9' />
			</mask>
			<g mask='url(#mask4_3703_23963)'>
				<path
					d='M249.5 187V181.488C249.5 181.213 249.6 180.979 249.8 180.788C250 180.596 250.238 180.5 250.513 180.5H256C256.275 180.5 256.511 180.598 256.706 180.794C256.902 180.99 257 181.225 257 181.5V185.5L254.5 188H250.5C250.225 188 249.99 187.902 249.794 187.706C249.598 187.511 249.5 187.275 249.5 187ZM247.013 180.125C246.963 179.85 247.017 179.602 247.175 179.381C247.333 179.161 247.55 179.025 247.825 178.975L253.25 178.013C253.525 177.963 253.773 178.017 253.994 178.175C254.215 178.333 254.35 178.55 254.4 178.825L254.525 179.5H253.5L253.413 179L248 179.963L248.5 182.788V186.275C248.367 186.2 248.252 186.1 248.156 185.975C248.061 185.85 248 185.708 247.975 185.55L247.013 180.125ZM250.5 181.5V187H254L256 185V181.5H250.5ZM252.75 186.25H253.75V184.75H255.25V183.75H253.75V182.25H252.75V183.75H251.25V184.75H252.75V186.25Z'
					fill='#1C1B1F'
				/>
			</g>
		</g>
		<g opacity='0.5'>
			<rect x='32' y='187' width='20' height='20' rx='2' fill='#F2F2F2' />
			<mask id='mask5_3703_23963' maskUnits='userSpaceOnUse' x='36' y='191' width='12' height='12'>
				<rect x='36' y='191' width='12' height='12' fill='#D9D9D9' />
			</mask>
			<g mask='url(#mask5_3703_23963)'>
				<path
					d='M38.125 200.15C37.8083 199.783 37.5542 199.375 37.3625 198.925C37.1708 198.475 37.05 198 37 197.5H38.025C38.075 197.867 38.1667 198.214 38.3 198.544C38.4333 198.873 38.6083 199.175 38.825 199.45L38.125 200.15ZM37 196.5C37.0667 196 37.1917 195.525 37.375 195.075C37.5583 194.625 37.8083 194.217 38.125 193.85L38.825 194.55C38.6083 194.825 38.4333 195.127 38.3 195.456C38.1667 195.785 38.075 196.133 38.025 196.5H37ZM41.475 201.975C40.975 201.925 40.5021 201.804 40.0563 201.612C39.6104 201.421 39.2 201.175 38.825 200.875L39.525 200.15C39.8167 200.367 40.1229 200.546 40.4438 200.687C40.7646 200.829 41.1083 200.925 41.475 200.975V201.975ZM39.55 193.85L38.825 193.125C39.2 192.825 39.6104 192.579 40.0563 192.387C40.5021 192.196 40.9833 192.075 41.5 192.025V193.025C41.125 193.075 40.775 193.171 40.45 193.312C40.125 193.454 39.825 193.633 39.55 193.85ZM40.75 199.25V194.75L44.25 197L40.75 199.25ZM42.5 201.975V200.975C43.5083 200.833 44.3438 200.387 45.0063 199.637C45.6688 198.887 46 198.008 46 197C46 195.992 45.6688 195.112 45.0063 194.362C44.3438 193.612 43.5083 193.167 42.5 193.025V192.025C43.7833 192.167 44.8542 192.708 45.7125 193.65C46.5708 194.592 47 195.708 47 197C47 198.292 46.5708 199.408 45.7125 200.35C44.8542 201.292 43.7833 201.833 42.5 201.975Z'
					fill='#1C1B1F'
				/>
			</g>
		</g>
		<g opacity='0.7'>
			<rect x='95' y='82' width='20' height='20' rx='2' fill='#F2F2F2' />
			<mask id='mask6_3703_23963' maskUnits='userSpaceOnUse' x='99' y='86' width='12' height='12'>
				<rect x='99' y='86' width='12' height='12' fill='#D9D9D9' />
			</mask>
			<g mask='url(#mask6_3703_23963)'>
				<path
					d='M102 94H106V93H102V94ZM102 92H108V91H102V92ZM101 96C100.725 96 100.49 95.9021 100.294 95.7063C100.098 95.5104 100 95.275 100 95V89C100 88.725 100.098 88.4896 100.294 88.2938C100.49 88.0979 100.725 88 101 88H104L105 89H109C109.275 89 109.51 89.0979 109.706 89.2938C109.902 89.4896 110 89.725 110 90V95C110 95.275 109.902 95.5104 109.706 95.7063C109.51 95.9021 109.275 96 109 96H101ZM101 95H109V90H104.588L103.588 89H101V95Z'
					fill='#1C1B1F'
				/>
			</g>
		</g>
		<g opacity='0.5'>
			<rect x='22' y='100' width='20' height='20' rx='2' fill='#F2F2F2' />
			<mask id='mask7_3703_23963' maskUnits='userSpaceOnUse' x='26' y='104' width='12' height='12'>
				<rect x='26' y='104' width='12' height='12' fill='#D9D9D9' />
			</mask>
			<g mask='url(#mask7_3703_23963)'>
				<path
					d='M29 115C28.725 115 28.4896 114.902 28.2938 114.706C28.0979 114.51 28 114.275 28 114V106C28 105.725 28.0979 105.489 28.2938 105.294C28.4896 105.098 28.725 105 29 105H33L36 108V114C36 114.275 35.9021 114.51 35.7063 114.706C35.5104 114.902 35.275 115 35 115H29ZM32.5 108.5V106H29V114H35V108.5H32.5Z'
					fill='#1C1B1F'
				/>
			</g>
		</g>
	</svg>
);

export default ReadyForExtractionIcon;
